import { render, staticRenderFns } from "./LocalisationRoutesMobileModal.vue?vue&type=template&id=425d89e2&"
import script from "./LocalisationRoutesMobileModal.vue?vue&type=script&lang=ts&"
export * from "./LocalisationRoutesMobileModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports